module.exports = __webpack_public_path__ + "media/conmex/bghead-a781a633.png";